import PropTypes from "prop-types";

import { alignItems, campaignCategories, strCode } from "../../../../../../consts";
import { audienceSetOptions } from "../../consts/audienceSetOptions";
import { t } from "../../../../../../services";

import {
  Caption,
  FlexContainers,
  Paragraph2,
  WrapperContainer
} from "../../../../../../components";
import { SectionSummaryStyled } from "./styled";

const AudienceSectionSummary = ({ audienceData, selectedCategory }) => {
  return audienceData ? (
    <SectionSummaryStyled
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <Paragraph2>
        {audienceData?.selectedMarkets
          .filter((m) => m.id)
          .map((m) => m?.value)
          .join(", ")}
      </Paragraph2>

      {audienceData.audienceSetOption === audienceSetOptions.APP && (
        <Paragraph2>{audienceData?.selectedApps.map((a) => a?.value).join(", ")}</Paragraph2>
      )}

      {audienceData.audienceSetOption === audienceSetOptions.DEVICE_TYPE && (
        <Paragraph2>{audienceData?.selectedDevices.map((d) => d?.value).join("\n")}</Paragraph2>
      )}

      {audienceData.audienceSetOption === audienceSetOptions.DUSN && (
        <Paragraph2>{audienceData?.selectedDusns.map((d) => d?.value).join("\n")}</Paragraph2>
      )}

      {audienceData.audienceSetOption === audienceSetOptions.USER && (
        <Paragraph2>{audienceData?.selectedUsers.map((d) => d?.value).join("\n")}</Paragraph2>
      )}

      {selectedCategory === campaignCategories.firmwareUpdate &&
        audienceData?.versions?.length > 0 && (
          <WrapperContainer>
            <Caption>{t(strCode.CURRENT_FW_VERSION_TITLE.toUpperCase())}</Caption>
            <Paragraph2>{audienceData?.versions.map((v) => v?.value).join(", ")}</Paragraph2>
          </WrapperContainer>
        )}
    </SectionSummaryStyled>
  ) : null;
};

AudienceSectionSummary.propTypes = {
  audienceData: PropTypes.shape({
    audienceSetOption: PropTypes.string.isRequired,
    selectedApps: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    selectedDevices: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    selectedDusns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    selectedUsers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    selectedMarkets: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    versions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired,
  selectedCategory: PropTypes.string.isRequired
};

export default AudienceSectionSummary;
